// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"a58afed5","960":"672393b2"}[chunkId] + ".chunk.js";
};